import { Link } from '@mui/material';
import { orderCardHref } from './suggestionColumns';

/**
 * Odsyłacz z powodu zwolnienia wariantu do zlecenia, które zajęło pojazd
 * (`releasedFor` w szczegółach zlecenia, API `user-offers/release-reason.ts`).
 */
export interface ReleasedFor {
  /** Fragment tekstu powodu, który wskazuje zlecenie („PL/R/…” albo dawne „#812”). */
  token: string;
  userOfferId: number;
  /** Numer z TMS; `null` = zlecenie bez numeru — zostaje „#id”. */
  externalId: string | null;
}

/**
 * Powód zwolnienia wariantu z numerem zlecenia jako linkiem do karty
 * zlecenia w nowej karcie — jak inne odsyłacze do zleceń w rekomendacjach
 * (07.10.2026, arkusz „Problemy poza brzmieniem”: „Pojazd obsadza zlecenie
 * #…” wstawiał numer rekordu, którego planista nie zna). Dawny powód
 * z numerem rekordu dostaje numer z TMS. Bez odsyłacza — sam tekst.
 */
export function ReleaseReasonText({
  reason,
  releasedFor,
}: {
  reason: string;
  releasedFor?: ReleasedFor | null;
}) {
  const at = releasedFor ? reason.indexOf(releasedFor.token) : -1;
  if (!releasedFor || at < 0) return <span>{reason}</span>;
  return (
    <span>
      {reason.slice(0, at)}
      <Link
        href={orderCardHref(releasedFor.userOfferId)}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{ whiteSpace: 'nowrap' }}
      >
        {releasedFor.externalId ?? releasedFor.token}
      </Link>
      {reason.slice(at + releasedFor.token.length)}
    </span>
  );
}
